import React, { useState } from "react";
import PropTypes from "prop-types";

// Font Awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

// Config
import useTranslate from "../../hooks/useTranslate";

// Components
import Button from "../Button";
import ReferenceNumberDialog from "../ReferenceNumberDialog";

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: 25,
    padding: theme.spacing(0, 4),
    minHeight: 50,
    minWidth: 195,
    backgroundColor: ({ anchorEl }) => anchorEl && "#E7F9FC"
  },
  chevron: {
    marginLeft: theme.spacing(1)
  },
  paper: {
    boxShadow: "0px 1px 3px #0000000A",
    border: "1px solid #EAEDF3"
  },
  list: {
    padding: "0"
  },
  menuItem: {
    padding: theme.spacing(2),
    fontSize: "15px",
    "&:hover": {
      backgroundColor: "#E7F9FC"
    }
  }
}));

const NewIncidentButton = ({ onClick }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles({ anchorEl });
  const getText = useTranslate();
  const [openRefDialog, setOpenRefDialog] = useState(false);

  const handleClick = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleOpenRefDialog = () => setOpenRefDialog(true);
  const handleCloseRefDialog = () => setOpenRefDialog(false);

  return (
    <>
      {openRefDialog && (
        <ReferenceNumberDialog open onClose={handleCloseRefDialog} />
      )}
      <Button
        className={classes.button}
        disableElevation
        onClick={handleClick}
        variant="outlined"
      >
        {getText("header.actionButtons.createButton")}{" "}
        <FontAwesomeIcon className={classes.chevron} icon={faChevronDown} />
      </Button>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        classes={{
          paper: classes.paper,
          list: classes.list
        }}
        elevation={1}
        getContentAnchorEl={null}
        id="create-case-menu"
        keepMounted
        onClose={handleClose}
        open={Boolean(anchorEl)}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
      >
        <MenuItem
          className={classes.menuItem}
          button
          onClick={handleOpenRefDialog}
        >
          {getText("createCasePage.newCaseFlow.startWithReferenceNumber")}
        </MenuItem>
        <MenuItem button className={classes.menuItem} onClick={onClick}>
          {getText("createCasePage.newCase")}
        </MenuItem>
      </Menu>
    </>
  );
};

NewIncidentButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default NewIncidentButton;
